// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-history-item {
   display: flex;
   align-items: center;
}

.comment-history-item .top {
   display: flex;
   align-items: baseline;
   padding: var(--padding-sm);
}

.comment-history-item .left {
   align-self: flex-start;
}

.comment-history-item .date {
   padding: var(--padding-sm);
}

.comment-history-item .username {
   padding: var(--padding-sm);
}

.comment-history-item .comment-message {
   padding: var(--padding-sm);
}

.comment-history-item .bottom {
   display: flex;
}

.comment-history-item .comment-action {
   padding: var(--padding);
}

.comment-history-item .rich-text-container {
   padding: var(--padding);
}

.comment-history-item .rich-text {
   display: inline-block;
}

.comments-view-top {
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 50px;
}

.right .bottom .comment span {
   padding: var(--padding);
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLComments/CommentsHistoryView/CommentHistoryView.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,qBAAqB;GACrB,0BAA0B;AAC7B;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,aAAa;GACb,8BAA8B;GAC9B,mBAAmB;GACnB,mBAAmB;AACtB;;AAEA;GACG,uBAAuB;AAC1B","sourcesContent":[".comment-history-item {\r\n   display: flex;\r\n   align-items: center;\r\n}\r\n\r\n.comment-history-item .top {\r\n   display: flex;\r\n   align-items: baseline;\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n.comment-history-item .left {\r\n   align-self: flex-start;\r\n}\r\n\r\n.comment-history-item .date {\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n.comment-history-item .username {\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n.comment-history-item .comment-message {\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n.comment-history-item .bottom {\r\n   display: flex;\r\n}\r\n\r\n.comment-history-item .comment-action {\r\n   padding: var(--padding);\r\n}\r\n\r\n.comment-history-item .rich-text-container {\r\n   padding: var(--padding);\r\n}\r\n\r\n.comment-history-item .rich-text {\r\n   display: inline-block;\r\n}\r\n\r\n.comments-view-top {\r\n   display: flex;\r\n   justify-content: space-between;\r\n   align-items: center;\r\n   margin-bottom: 50px;\r\n}\r\n\r\n.right .bottom .comment span {\r\n   padding: var(--padding);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
